function itemli(callback, directory="", append, loop) {
    var list = "";
    $.ajax({
        url: "//www.kontatsu.co.jp/wp/wp-content/themes/kontatsu-child/assets/json/" + directory + callback + ".jsonp",
        type: "GET",
        dataType: "jsonp",
        jsonpCallback: callback,
        error: function() {},
        success: function(json) {
            var len = json.length
              , display_num = "";
            if (loop)
                var display_num = loop;
            else
                var display_num = len;
            for (var caption = "", i = 0; i < display_num; i++)
                json[i].brand ? brand = `<p class="brand">${json[i].brand}</p>` : brand = "",
                json[i].cap ? caption = `<span class="caption">${json[i].cap}</span>` : caption = "",
                json[i].price ? price = `<p class="price">${json[i].price}<span>\u5186</span></p>` : price = "",
                json[i].url_m != "" ? list = `
                <div class="ranking-tab__item">
                    <a href="${json[i].url_o}" target="_top">
                        <div class="imgArea">
                            <img src="${json[i].img}" alt="${json[i].name}の画像" width="400" height="400" loading="lazy">
                        </div>
                        <div class="ranking-item__text">${brand}<p class="ranking-item__name">${json[i].name}</p>${caption}${price}</div>
                    </a>
                </div>` : list = "",
            $(append).append(list)
        }
    })
}

$(function(){
    itemli('rank_beer','ranking/','.Rank_b','');
    itemli('rank_sake','ranking/','.Rank_c','');
    itemli('rank_spirits','ranking/','.Rank_d','');
    itemli('rank_wine','ranking/','.Rank_e','');
    itemli('rank_whiskey','ranking/','.Rank_f','');
    itemli('rank_cocktail','ranking/','.Rank_g','');
});